import { a as EditorClientPlugin, b as BdHiJsClientPlugin, c as WikiClientPlugin } from "./BdHiJs-DSYXPf2b.js";
const ClientPlugins = [
  EditorClientPlugin,
  BdHiJsClientPlugin,
  WikiClientPlugin
];
export {
  ClientPlugins
};
//# sourceMappingURL=client.es.js.map
